// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/registration/register/documents/firstparty/v1/document.proto

/* eslint-disable */

/**
 * Type of subject a document can belong to
 */
export const ApiSubjectType = {
  /** SUBJECT_TYPE_UNSPECIFIED - Unspecified subject type */
  SUBJECT_TYPE_UNSPECIFIED: "SUBJECT_TYPE_UNSPECIFIED",
  /** Organization - Document belongs to an organization */
  Organization: "Organization",
  /** Stakeholder - Document belongs to a stakeholder */
  Stakeholder: "Stakeholder",
} as const;

export type ApiSubjectType = typeof ApiSubjectType[keyof typeof ApiSubjectType];

export namespace ApiSubjectType {
  export type SUBJECT_TYPE_UNSPECIFIED = typeof ApiSubjectType.SUBJECT_TYPE_UNSPECIFIED;
  export type Organization = typeof ApiSubjectType.Organization;
  export type Stakeholder = typeof ApiSubjectType.Stakeholder;
}

export function apiSubjectTypeFromJSON(object: any): ApiSubjectType {
  switch (object) {
    case 0:
    case "SUBJECT_TYPE_UNSPECIFIED":
      return ApiSubjectType.SUBJECT_TYPE_UNSPECIFIED;
    case 1:
    case "Organization":
      return ApiSubjectType.Organization;
    case 2:
    case "Stakeholder":
      return ApiSubjectType.Stakeholder;
    default:
      return ApiSubjectType.SUBJECT_TYPE_UNSPECIFIED;
  }
}

export function apiSubjectTypeToJSON(object: ApiSubjectType): string {
  switch (object) {
    case ApiSubjectType.SUBJECT_TYPE_UNSPECIFIED:
      return "SUBJECT_TYPE_UNSPECIFIED";
    case ApiSubjectType.Organization:
      return "Organization";
    case ApiSubjectType.Stakeholder:
      return "Stakeholder";
    default:
      return "SUBJECT_TYPE_UNSPECIFIED";
  }
}

/**
 * Type of a registration document
 */
export const ApiDocType = {
  /** DOC_TYPE_UNSPECIFIED - Unspecified document type */
  DOC_TYPE_UNSPECIFIED: "DOC_TYPE_UNSPECIFIED",
  /** kbis - Kbis extract (company registration certificate) */
  kbis: "kbis",
  /** bylaw - Company bylaws */
  bylaw: "bylaw",
  /** poa - Proof of address */
  poa: "poa",
  /** poi - Proof of identity */
  poi: "poi",
  /** contract - Signed contract */
  contract: "contract",
  /** power - Power of attorney */
  power: "power",
  /** deposit_request - Capital deposit request */
  deposit_request: "deposit_request",
  /** deposit_certificate - Capital deposit certificate */
  deposit_certificate: "deposit_certificate",
  /** deposit_capital_zip - Capital deposit zip archive */
  deposit_capital_zip: "deposit_capital_zip",
  /** deposit_release - Capital deposit release document */
  deposit_release: "deposit_release",
  /** fund_origin_certificate - Fund origin certificate */
  fund_origin_certificate: "fund_origin_certificate",
  /** register_power - Register power document */
  register_power: "register_power",
  /** residence_permit - Residence permit */
  residence_permit: "residence_permit",
  /** second_poi - Second proof of identity */
  second_poi: "second_poi",
  /** partnership_agreement - Partnership agreement */
  partnership_agreement: "partnership_agreement",
  /** rap - RAP document */
  rap: "rap",
  /** german_bank_statement - German bank statement */
  german_bank_statement: "german_bank_statement",
  /** financial_statement - Financial statement */
  financial_statement: "financial_statement",
  /** tax_exemption_notice - Tax exemption notice */
  tax_exemption_notice: "tax_exemption_notice",
} as const;

export type ApiDocType = typeof ApiDocType[keyof typeof ApiDocType];

export namespace ApiDocType {
  export type DOC_TYPE_UNSPECIFIED = typeof ApiDocType.DOC_TYPE_UNSPECIFIED;
  export type kbis = typeof ApiDocType.kbis;
  export type bylaw = typeof ApiDocType.bylaw;
  export type poa = typeof ApiDocType.poa;
  export type poi = typeof ApiDocType.poi;
  export type contract = typeof ApiDocType.contract;
  export type power = typeof ApiDocType.power;
  export type deposit_request = typeof ApiDocType.deposit_request;
  export type deposit_certificate = typeof ApiDocType.deposit_certificate;
  export type deposit_capital_zip = typeof ApiDocType.deposit_capital_zip;
  export type deposit_release = typeof ApiDocType.deposit_release;
  export type fund_origin_certificate = typeof ApiDocType.fund_origin_certificate;
  export type register_power = typeof ApiDocType.register_power;
  export type residence_permit = typeof ApiDocType.residence_permit;
  export type second_poi = typeof ApiDocType.second_poi;
  export type partnership_agreement = typeof ApiDocType.partnership_agreement;
  export type rap = typeof ApiDocType.rap;
  export type german_bank_statement = typeof ApiDocType.german_bank_statement;
  export type financial_statement = typeof ApiDocType.financial_statement;
  export type tax_exemption_notice = typeof ApiDocType.tax_exemption_notice;
}

export function apiDocTypeFromJSON(object: any): ApiDocType {
  switch (object) {
    case 0:
    case "DOC_TYPE_UNSPECIFIED":
      return ApiDocType.DOC_TYPE_UNSPECIFIED;
    case 1:
    case "kbis":
      return ApiDocType.kbis;
    case 2:
    case "bylaw":
      return ApiDocType.bylaw;
    case 3:
    case "poa":
      return ApiDocType.poa;
    case 4:
    case "poi":
      return ApiDocType.poi;
    case 5:
    case "contract":
      return ApiDocType.contract;
    case 6:
    case "power":
      return ApiDocType.power;
    case 7:
    case "deposit_request":
      return ApiDocType.deposit_request;
    case 8:
    case "deposit_certificate":
      return ApiDocType.deposit_certificate;
    case 9:
    case "deposit_capital_zip":
      return ApiDocType.deposit_capital_zip;
    case 10:
    case "deposit_release":
      return ApiDocType.deposit_release;
    case 11:
    case "fund_origin_certificate":
      return ApiDocType.fund_origin_certificate;
    case 12:
    case "register_power":
      return ApiDocType.register_power;
    case 13:
    case "residence_permit":
      return ApiDocType.residence_permit;
    case 14:
    case "second_poi":
      return ApiDocType.second_poi;
    case 15:
    case "partnership_agreement":
      return ApiDocType.partnership_agreement;
    case 16:
    case "rap":
      return ApiDocType.rap;
    case 17:
    case "german_bank_statement":
      return ApiDocType.german_bank_statement;
    case 18:
    case "financial_statement":
      return ApiDocType.financial_statement;
    case 19:
    case "tax_exemption_notice":
      return ApiDocType.tax_exemption_notice;
    default:
      return ApiDocType.DOC_TYPE_UNSPECIFIED;
  }
}

export function apiDocTypeToJSON(object: ApiDocType): string {
  switch (object) {
    case ApiDocType.DOC_TYPE_UNSPECIFIED:
      return "DOC_TYPE_UNSPECIFIED";
    case ApiDocType.kbis:
      return "kbis";
    case ApiDocType.bylaw:
      return "bylaw";
    case ApiDocType.poa:
      return "poa";
    case ApiDocType.poi:
      return "poi";
    case ApiDocType.contract:
      return "contract";
    case ApiDocType.power:
      return "power";
    case ApiDocType.deposit_request:
      return "deposit_request";
    case ApiDocType.deposit_certificate:
      return "deposit_certificate";
    case ApiDocType.deposit_capital_zip:
      return "deposit_capital_zip";
    case ApiDocType.deposit_release:
      return "deposit_release";
    case ApiDocType.fund_origin_certificate:
      return "fund_origin_certificate";
    case ApiDocType.register_power:
      return "register_power";
    case ApiDocType.residence_permit:
      return "residence_permit";
    case ApiDocType.second_poi:
      return "second_poi";
    case ApiDocType.partnership_agreement:
      return "partnership_agreement";
    case ApiDocType.rap:
      return "rap";
    case ApiDocType.german_bank_statement:
      return "german_bank_statement";
    case ApiDocType.financial_statement:
      return "financial_statement";
    case ApiDocType.tax_exemption_notice:
      return "tax_exemption_notice";
    default:
      return "DOC_TYPE_UNSPECIFIED";
  }
}

/** Document represents a document attached to an organization or stakeholder during registration */
export interface ApiDocument {
  /** Unique identifier of the document */
  readonly id: string;
  /** Type of the subject the document belongs to */
  readonly subjectType: ApiSubjectType;
  /** Unique identifier of the subject the document belongs to */
  readonly subjectId: string;
  /** Type of the document */
  readonly docType: ApiDocType;
  /** Subtype of the document (e.g., eu_passport) */
  readonly docSubtype?:
    | string
    | null
    | undefined;
  /** Name of the document file */
  readonly name: string;
  /** Size of the document in bytes */
  readonly size: number;
  /** URL to download the document */
  readonly url: string;
}

export const ApiDocument: MessageFns<ApiDocument> = {
  fromJSON(object: any): ApiDocument {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      subjectType: isSet(object.subject_type)
        ? apiSubjectTypeFromJSON(object.subject_type)
        : ApiSubjectType.SUBJECT_TYPE_UNSPECIFIED,
      subjectId: isSet(object.subject_id) ? globalThis.String(object.subject_id) : "",
      docType: isSet(object.doc_type) ? apiDocTypeFromJSON(object.doc_type) : ApiDocType.DOC_TYPE_UNSPECIFIED,
      docSubtype: isSet(object.doc_subtype) ? globalThis.String(object.doc_subtype) : null,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      size: isSet(object.size) ? globalThis.Number(object.size) : 0,
      url: isSet(object.url) ? globalThis.String(object.url) : "",
    };
  },

  toJSON(message: ApiDocument): unknown {
    const obj: any = {};
    if (message.id !== undefined && message.id !== null) {
      obj.id = message.id;
    }
    if (message.subjectType !== undefined && message.subjectType !== null) {
      obj.subject_type = apiSubjectTypeToJSON(message.subjectType);
    }
    if (message.subjectId !== undefined && message.subjectId !== null) {
      obj.subject_id = message.subjectId;
    }
    if (message.docType !== undefined && message.docType !== null) {
      obj.doc_type = apiDocTypeToJSON(message.docType);
    }
    if (message.docSubtype !== undefined && message.docSubtype !== null) {
      obj.doc_subtype = message.docSubtype;
    }
    if (message.name !== undefined && message.name !== null) {
      obj.name = message.name;
    }
    if (message.size !== undefined && message.size !== null) {
      obj.size = Math.round(message.size);
    }
    if (message.url !== undefined && message.url !== null) {
      obj.url = message.url;
    }
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
